<template>
  <!-- todo: when in use, replace for mdi-alternative icon -->
  <svg
    class="crv-catalog-solid crv-svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="6 5 22 22"
  >
    <path
      fill-rule="evenodd"
      d="M24.5619279,11.5014546 C23.0396793,11.5847578 20.0140712,11.8879706 18.1462611,12.9904652 C18.0173699,13.0665363 17.9443131,13.2018035 17.9443131,13.3432313 L17.9443131,23.0897016 C17.9443131,23.3990751 18.2951525,23.5946098 18.590991,23.4510391 C20.512691,22.5183651 23.2919059,22.263902 24.6660964,22.1942595 C25.1352712,22.1704203 25.4999999,21.8077435 25.4999999,21.3730135 L25.4999999,12.323772 C25.5002775,11.8493993 25.0736034,11.4735976 24.5619279,11.5014546 Z M16.8537387,12.9904652 C14.9862063,11.8879706 11.9605982,11.5850256 10.4383496,11.5014546 C9.92667407,11.4735976 9.5,11.8493993 9.5,12.323772 L9.5,21.3732814 C9.5,21.8082793 9.86472855,22.1709561 10.3339034,22.1945274 C11.7086494,22.2641699 14.4892532,22.5189008 16.4109532,23.4521105 C16.7059583,23.5954134 17.0556866,23.4001465 17.0556866,23.0915766 L17.0556866,13.3384099 C17.0556866,13.1967142 16.9829076,13.0668041 16.8537387,12.9904652 Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'CrvCatalogSolid',
}
</script>